import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./ChildBottomNav.css";

function ChildBottomNav() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("selectedUser");
    navigate("/");
  };

  return (
    <nav className="child-bottom-nav" aria-label="Навігація дитини">
      <NavLink to="/child">Завдання</NavLink>
      <NavLink to="/child-shop">Магазин</NavLink>
      <NavLink to="/child-profile">Профіль</NavLink>
      <button type="button" onClick={handleLogout}>
        Вийти
      </button>
    </nav>
  );
}

export default ChildBottomNav;
